// To mock API Responses for testing components
export const mockPatchingDates = [
  {
    account_id: "b74114ef-7ad0-4181-98b7-40259509d53e",
    account_name: "AZSUB-OC-AME-NES-SBX",
    last_patch_date: "nan",
    next_patch_date: "2021-03-02 18:24:17"
  }
]

export const mockAccountList = {
  projectID: "PROJ0036892",
  project_name: "Nestlé",
  account_list:
    "us-con-gcp-sbx-0000292-020421,b74114ef-7ad0-4181-98b7-40259509d53e",
  account_attribute: [
    {
      account_number: "uscongcpsbx0000292020421",
      account_name: "us-con-gcp-sbx-0000292",
      project_name: "Nestlé",
      account_environment: "GCP Sandbox"
    },
    {
      account_number: "b74114ef7ad0418198b740259509d53e",
      account_name: "AZSUB-OC-AME-NES-SBX",
      project_name: "Nestlé",
      account_environment: "Azure Sandbox"
    }
  ]
}

export const mockAdidasAccountsList = {
  projectID: "p000256",
  project_name: "Adidas - Tax Compliance Solution",
  account_list: "dcuk-aws-acct-143,dcuk-aws-acct-144,dcuk-aws-acct-145",
  account_attribute: [
    {
      account_environment: "Shared Services Account",
      account_name: "dcuk-aws-acct-143",
      account_number: "126917567464",
      project_name: "Adidas - Tax Compliance Solution"
    },
    {
      account_environment: "Non-Production Account",
      account_name: "dcuk-aws-acct-144",
      account_number: "189839901482",
      project_name: "Adidas - Tax Compliance Solution"
    },
    {
      account_environment: "Production Account",
      account_name: "dcuk-aws-acct-145",
      account_number: "000451717204",
      project_name: "Adidas - Tax Compliance Solution"
    }
  ],
  accounts: []
}

export const mockSLAIncidentCount = {
  SLA_RESPONSE_BREACHED: 127,
  SLA_RESOLUTION_BREACHED: 125
}

export const mockSLAIncidentCountP1 = {
  SLA_RESPONSE_BREACHED: 61,
  SLA_RESOLUTION_BREACHED: 60
}

export const mockSLAIncidentCountP2 = {
  SLA_RESPONSE_BREACHED: 16,
  SLA_RESOLUTION_BREACHED: 16
}

export const mockSLAIncidentCountP3 = {
  SLA_RESPONSE_BREACHED: 30,
  SLA_RESOLUTION_BREACHED: 29
}

export const mockSLAIncidentCountP4 = {
  SLA_RESPONSE_BREACHED: 20,
  SLA_RESOLUTION_BREACHED: 20
}

export const mockSLACompletedIncidentCount = {
  SLA_RESPONSE_COMPLETED: 127,
  SLA_RESOLUTION_COMPLETED: 125
}

export const mockSLACompletedIncidentCountP1 = {
  SLA_RESPONSE_COMPLETED: 64,
  SLA_RESOLUTION_COMPLETED: 65
}

export const mockSLACompletedIncidentCountP2 = {
  SLA_RESPONSE_COMPLETED: 109,
  SLA_RESOLUTION_COMPLETED: 109
}

export const mockSLACompletedIncidentCountP3 = {
  SLA_RESPONSE_COMPLETED: 95,
  SLA_RESOLUTION_COMPLETED: 96
}

export const mockSLACompletedIncidentCountP4 = {
  SLA_RESPONSE_COMPLETED: 105,
  SLA_RESOLUTION_COMPLETED: 105
}

export const mockPriorityIncidentCount = {
  TOTAL: 125,
  P1: 58,
  P2: 14,
  P3: 29,
  P4: 20,
  P5: 4
}

export const mockAccPriorityIncidentCount = {
  uscongcpsbx0000292020421: {
    PRIORITY: { P1: 0, P2: 0, P3: 21, P4: 1, P5: 0 }
  },
  b74114ef7ad0418198b740259509d53e: {
    PRIORITY: { P1: 0, P2: 0, P3: 8, P4: 1, P5: 0 }
  },
  TOTAL: 31
}

export const mockIncidentCountByIncState = {
  TOTAL: 170,
  NEW: 122,
  CLOSED: 36,
  ACTIVE: 4,
  "AWAITING USER INFO": 1,
  RESOLVED: 5,
  "AWAITING PROBLEM": 2,
  "AWAITING EVIDENCE": 0
}

export const mockIncidentCountByRemediation = {
  AUTO_REMEDIATED: 125,
  MANUALLY_REMEDIATED: 37
}

export const mockPriorityCRCount = {
  TOTAL: 100,
  P1: 20,
  P2: 15,
  P3: 24,
  P4: 36,
  P5: 5
}

export const mockAccPriorityCRCount = {
  uscongcpsbx0000292020421: { PRIORITY: { P1: 0, P2: 0, P3: 0, P4: 0, P5: 2 } },
  b74114ef7ad0418198b740259509d53e: {
    PRIORITY: { P1: 0, P2: 0, P3: 0, P4: 0, P5: 2 }
  },
  TOTAL: 4
}

export const mockCRCountByState = {
  TOTAL: 80,
  NEW: 48,
  SCHEDULED: 22,
  ASSESS: 8,
  AUTHORIZE: 1,
  IMPLEMENT: 1,
  REVIEW: 10,
  CLOSED: 5,
  CANCELED: 5
}

export const mockCRcountByCategory = {
  SERVER: 36,
  ENVIRONMENT: 20,
  SECURITY: 9,
  PATCHING: 6,
  SERVICES: 3,
  NETWORK: 2,
  OTHER: 2,
  SERVICENOW: 1,
  "USER ACCESS CONTROL": 1
}

export const mockrojectTeamInfo = [
  {
    primary_contact: {
      first_name: "Joshua",
      last_name: "Rucker",
      email: "jorucker@deloitte.com"
    },
    service_delivery_manager: {
      first_name: "Abraham",
      last_name: "Martinez",
      email: "abmartinez@deloitte.com"
    },
    pod_primary_team_members: [
      {
        first_name: "Joshua",
        last_name: "Rucker",
        email: "jorucker@deloitte.com"
      },
      {
        first_name: "Minnie",
        last_name: "Wadhwa",
        email: "minwadhwa@deloitte.com"
      }
    ]
  }
]

export const mockIncidentDetails = [
  {
    incident_number: "INC0118543",
    priority: "3 - Moderate",
    environment: "Sandbox",
    category: "SECURITY",
    sub_category: "LOG EVENT",
    created_date: "2021-03-09 19:05:12",
    assigned_to: "Abraham Martinez",
    short_description:
      "Splunk Alert : Azure Security Center - Access from an unusual location to a storage blob container",
    notes:
      "2021-03-14 20:00:03 - System (Additional comments)Incident automatically closed after 5 days in the Resolved state.2021-03-09 19:56:39 - Kyle Kleier (Additional comments)Project team member was trying to connect and forgot to connect to in-house VPN - tthis is a false alarm",
    incident_state: "New",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-03-09 19:05:12",
    inc_closed_at: "2021-03-14 20:00:03",
    inc_resolved_at: "2021-03-09 19:56:39",
    project_name: "Nestlé",
    account_name: "AZSUB-OC-AME-NES-SBX",
    account_id: "b74114ef7ad0418198b740259509d53e",
    inc_sys_id: "1d50a161dbb2e8103cdde415ca961960",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "AZSUB-OC-AME-NES-SBX"
  },
  {
    incident_number: "INC0118553",
    priority: "1 - Critical",
    environment: "Sandbox",
    category: "SECURITY",
    sub_category: "LOG EVENT",
    created_date: "2021-03-09 19:05:12",
    assigned_to: "Abraham Martinez",
    short_description:
      "Splunk Alert : Azure Security Center - Access from an unusual location to a storage blob container",
    notes:
      "2021-03-14 20:00:03 - System (Additional comments)Incident automatically closed after 5 days in the Resolved state.2021-03-09 19:56:39 - Kyle Kleier (Additional comments)Project team member was trying to connect and forgot to connect to in-house VPN - tthis is a false alarm",
    incident_state: "New",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-03-09 19:05:12",
    inc_closed_at: "2021-03-14 20:00:03",
    inc_resolved_at: "2021-03-09 19:56:39",
    project_name: "Nestlé",
    account_name: "AZSUB-OC-AME-NES-SBX",
    account_id: "b74114ef7ad0418198b740259509d53e",
    inc_sys_id: "1d50a161dbb2e8103cdde415ca961960",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "AZSUB-OC-AME-NES-SBX"
  },
  {
    incident_number: "INC0118563",
    priority: "3 - Moderate",
    environment: "Sandbox",
    category: "SECURITY",
    sub_category: "LOG EVENT",
    created_date: "2021-03-09 19:05:12",
    assigned_to: "Abraham Martinez",
    short_description:
      "Splunk Alert : Azure Security Center - Access from an unusual location to a storage blob container",
    notes:
      "2021-03-14 20:00:03 - System (Additional comments)Incident automatically closed after 5 days in the Resolved state.2021-03-09 19:56:39 - Kyle Kleier (Additional comments)Project team member was trying to connect and forgot to connect to in-house VPN - tthis is a false alarm",
    incident_state: "Active",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-03-09 19:05:12",
    inc_closed_at: "2021-03-14 20:00:03",
    inc_resolved_at: "2021-03-09 19:56:39",
    project_name: "Nestlé",
    account_name: "AZSUB-OC-AME-NES-SBX",
    account_id: "b74114ef7ad0418198b740259509d53e",
    inc_sys_id: "1d50a161dbb2e8103cdde415ca961960",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "AZSUB-OC-AME-NES-SBX"
  },
  {
    incident_number: "INC0118533",
    priority: "3 - Moderate",
    environment: "Sandbox",
    category: "SECURITY",
    sub_category: "LOG EVENT",
    created_date: "2021-03-09 19:05:12",
    assigned_to: "Abraham Martinez",
    short_description:
      "Splunk Alert : Azure Security Center - Access from an unusual location to a storage blob container",
    notes:
      "2021-03-14 20:00:03 - System (Additional comments)Incident automatically closed after 5 days in the Resolved state.2021-03-09 19:56:39 - Kyle Kleier (Additional comments)Project team member was trying to connect and forgot to connect to in-house VPN - tthis is a false alarm",
    incident_state: "Closed",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-03-09 19:05:12",
    inc_closed_at: "2021-03-14 20:00:03",
    inc_resolved_at: "2021-03-09 19:56:39",
    project_name: "Nestlé",
    account_name: "AZSUB-OC-AME-NES-SBX",
    account_id: "b74114ef7ad0418198b740259509d53e",
    inc_sys_id: "1d50a161dbb2e8103cdde415ca961960",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "AZSUB-OC-AME-NES-SBX"
  },
  {
    incident_number: "INC0118534",
    priority: "3 - Moderate",
    environment: "Sandbox",
    category: "SECURITY",
    sub_category: "LOG EVENT",
    created_date: "2021-03-09 19:05:43",
    assigned_to: "Joshua Rucker",
    short_description:
      "Azure LogAnalytics Event: Create or update diagnostic settings for resources",
    notes:
      "2021-03-14 20:00:03 - System (Additional comments)Incident automatically closed after 5 days in the Resolved state.2021-03-09 19:58:13 - Kyle Kleier (Additional comments)issue resolved",
    incident_state: "Closed",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-03-09 19:05:43",
    inc_closed_at: "2021-03-14 20:00:03",
    inc_resolved_at: "2021-03-09 19:58:13",
    project_name: "Nestlé",
    account_name: "AZSUB-OC-AME-NES-SBX",
    account_id: "b74114ef7ad0418198b740259509d53e",
    inc_sys_id: "7470ad61dbb2e8103cdde415ca961966",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "AZSUB-OC-AME-NES-SBX"
  },
  {
    incident_number: "INC0118535",
    priority: "3 - Moderate",
    environment: "Sandbox",
    category: "SECURITY",
    sub_category: "LOG EVENT",
    created_date: "2021-03-09 19:06:42",
    assigned_to: "Abraham Martinez",
    short_description:
      "OCM Compliance Alert : Policy [DET_0014_SQL_SERVER_AUDITING_ENABLED_v1.0] is Non Compliant in the Subscription b74114ef-7ad0",
    notes:
      "2021-03-14 20:00:11 - System (Additional comments)Incident automatically closed after 5 days in the Resolved state.2021-03-09 19:44:35 - Kyle Kleier (Additional comments)this was auto remediated by OCM",
    incident_state: "Closed",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-03-09 19:06:42",
    inc_closed_at: "2021-03-14 20:00:11",
    inc_resolved_at: "2021-03-09 19:44:35",
    project_name: "Nestlé",
    account_name: "AZSUB-OC-AME-NES-SBX",
    account_id: "b74114ef7ad0418198b740259509d53e",
    inc_sys_id: "dba061a9db3a6c10052ddda5ca9619f4",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "AZSUB-OC-AME-NES-SBX"
  },
  {
    incident_number: "INC0118537",
    priority: "3 - Moderate",
    environment: "Sandbox",
    category: "SECURITY",
    sub_category: "OTHER",
    created_date: "2021-03-09 19:08:25",
    assigned_to: "Abraham Martinez",
    short_description:
      "Splunk Alert : RL OC - Storage Accounts without Secure transfer enabled",
    notes:
      "2021-03-14 21:00:02 - System (Additional comments)Incident automatically closed after 5 days in the Resolved state.2021-03-09 20:00:18 - Kyle Kleier (Additional comments)OC auto remediation - > Storage accounts have been enabled with Secure transfer",
    incident_state: "Closed",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-03-09 19:08:25",
    inc_closed_at: "2021-03-14 21:00:02",
    inc_resolved_at: "2021-03-09 20:00:18",
    project_name: "Nestlé",
    account_name: "AZSUB-OC-AME-NES-SBX",
    account_id: "b74114ef7ad0418198b740259509d53e",
    inc_sys_id: "e811e1e1dbb2e8103cdde415ca96194c",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "AZSUB-OC-AME-NES-SBX"
  },
  {
    incident_number: "INC0118983",
    priority: "1 - Critical",
    environment: "Azure Sandbox",
    category: "SERVER",
    sub_category: "DOWN/OFFLINE",
    created_date: "2021-04-15 18:36:27",
    assigned_to: "Abraham Martinez",
    short_description: "MW Test: Azure Server 1 is down.",
    notes:
      "2021-04-15 18:51:28 - Minnie Wadhwa (Additional comments)Issue is resolved2021-04-15 18:46:51 - Minnie Wadhwa (Additional comments)In progress to resolve",
    incident_state: "Closed",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-04-15 18:36:27",
    inc_closed_at: "2021-04-15 18:58:05",
    inc_resolved_at: "2021-04-15 18:51:28",
    project_name: "Nestlé",
    account_name: "AZSUB-OC-AME-NES-SBX",
    account_id: "b74114ef7ad0418198b740259509d53e",
    inc_sys_id: "f09c3795dbe760d0052ddda5ca9619e6",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "AZSUB-OC-AME-NES-SBX"
  },
  {
    incident_number: "INC0118986",
    priority: "1 - Critical",
    environment: "Azure Sandbox",
    category: "SERVER",
    sub_category: "PERFORMANCE",
    created_date: "2021-04-15 19:08:59",
    assigned_to: "Abraham Martinez",
    short_description:
      "MW Test: Server XX resolves a non-responsive address when connecting to itself",
    notes:
      "2021-04-15 19:21:54 - Minnie Wadhwa (Additional comments)Issue resolved",
    incident_state: "Closed",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-04-15 19:08:59",
    inc_closed_at: "2021-04-15 19:22:01",
    inc_resolved_at: "2021-04-15 19:21:54",
    project_name: "Nestlé",
    account_name: "AZSUB-OC-AME-NES-SBX",
    account_id: "b74114ef7ad0418198b740259509d53e",
    inc_sys_id: "a5040425dbefe0d03cdde415ca9619c0",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "AZSUB-OC-AME-NES-SBX"
  },
  {
    incident_number: "INC0118538",
    priority: "4 - Low",
    environment: "Sandbox",
    category: "SERVER",
    sub_category: "PERFORMANCE",
    created_date: "2021-03-09 19:11:04",
    assigned_to: "Abraham Martinez",
    short_description:
      "Intermittent connectivity issues with Nestle Azure Dev Instance",
    notes:
      "2021-03-14 21:00:02 - System (Additional comments)Incident automatically closed after 5 days in the Resolved state.2021-03-09 20:02:39 - Kyle Kleier (Additional comments)issue resolved",
    incident_state: "Closed",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-03-09 19:11:04",
    inc_closed_at: "2021-03-14 21:00:01",
    inc_resolved_at: "2021-03-09 20:02:39",
    project_name: "Nestlé",
    account_name: "AZSUB-OC-AME-NES-SBX",
    account_id: "b74114ef7ad0418198b740259509d53e",
    inc_sys_id: "dfa129e1dbb2e8103cdde415ca96192c",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "AZSUB-OC-AME-NES-SBX"
  },
  {
    incident_number: "INC0118536",
    priority: "3 - Moderate",
    environment: "Sandbox",
    category: "NETWORK",
    sub_category: "CONNECTIVITY",
    created_date: "2021-03-09 19:07:51",
    assigned_to: "Abraham Martinez",
    short_description: "Splunk Alert : RL OC - Azure_NSG Inbound",
    notes:
      "2021-03-14 20:00:11 - System (Additional comments)Incident automatically closed after 5 days in the Resolved state.2021-03-09 19:59:13 - Kyle Kleier (Additional comments)auto remediated - OC rules have restricted access to SG 0.0.0.0/0",
    incident_state: "Closed",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-03-09 19:07:51",
    inc_closed_at: "2021-03-14 20:00:11",
    inc_resolved_at: "2021-03-09 19:59:13",
    project_name: "Nestlé",
    account_name: "AZSUB-OC-AME-NES-SBX",
    account_id: "b74114ef7ad0418198b740259509d53e",
    inc_sys_id: "8cf06561dbb2e8103cdde415ca961903",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "AZSUB-OC-AME-NES-SBX"
  }
]

export const mockIncDetailsSLA = [
  {
    incident_number: "INC0198105",
    priority: "1 - Critical",
    environment: "",
    category: "N/A",
    sub_category: "N/A",
    created_date: "2021-04-27 08:35:31",
    assigned_to: "",
    short_description: "test",
    notes: "",
    incident_state: "New",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-04-27 08:35:31",
    inc_closed_at: "",
    inc_resolved_at: "",
    project_name: "Nestlé",
    account_name: "us-con-gcp-sbx-0000292",
    account_id: "uscongcpsbx0000292020421",
    inc_sys_id: "071623c5dbb72c503cdde415ca961937",
    caller: "Dhruv Pankajbhai Soni",
    caller_email: "dhrsoni@deloitte.com",
    inc_cmdb_ci: "us-con-gcp-sbx-0000292",
    sla_response_breached: "TRUE",
    sla_resolution_breached: "TRUE"
  },
  {
    incident_number: "INC0198141",
    priority: "1 - Critical",
    environment: "",
    category: "N/A",
    sub_category: "N/A",
    created_date: "2021-04-27 13:31:22",
    assigned_to: "",
    short_description: "test desc",
    notes: "",
    incident_state: "New",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-04-27 13:31:22",
    inc_closed_at: "",
    inc_resolved_at: "",
    project_name: "Nestlé",
    account_name: "",
    inc_sys_id: "09d9605ddbbba094052ddda5ca96197f",
    caller: "Dhruv Pankajbhai Soni",
    caller_email: "dhrsoni@deloitte.com",
    inc_cmdb_ci: "",
    sla_response_breached: "TRUE",
    sla_resolution_breached: "TRUE"
  },
  {
    incident_number: "INC0119047",
    priority: "1 - Critical",
    environment: "",
    category: "N/A",
    sub_category: "N/A",
    created_date: "2021-04-20 19:35:11",
    assigned_to: "",
    short_description: "ghfh",
    notes: "",
    incident_state: "New",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-04-20 19:35:11",
    inc_closed_at: "",
    inc_resolved_at: "",
    project_name: "Nestlé",
    account_name: "us-con-gcp-sbx-0000292",
    account_id: "uscongcpsbx0000292020421",
    inc_sys_id: "b5f9f903db672414052ddda5ca961989",
    caller: "Dhruv Pankajbhai Soni",
    caller_email: "dhrsoni@deloitte.com",
    inc_cmdb_ci: "us-con-gcp-sbx-0000292",
    sla_response_breached: "TRUE",
    sla_resolution_breached: "TRUE"
  },
  {
    incident_number: "INC0119082",
    priority: "3 - Moderate",
    environment: "",
    category: "N/A",
    sub_category: "N/A",
    created_date: "2021-04-21 19:24:41",
    assigned_to: "",
    short_description: "test1",
    notes: "",
    incident_state: "New",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-04-21 19:24:41",
    inc_closed_at: "",
    inc_resolved_at: "",
    project_name: "Nestlé",
    account_name: "us-con-gcp-sbx-0000292",
    account_id: "uscongcpsbx0000292020421",
    inc_sys_id: "ac114f97dbe324103cdde415ca96193b",
    caller: "Syyad Khan",
    caller_email: "syykhan@deloitte.com",
    inc_cmdb_ci: "",
    sla_response_breached: "TRUE",
    sla_resolution_breached: "TRUE"
  },
  {
    incident_number: "INC0198197",
    priority: "1 - Critical",
    environment: "",
    category: "N/A",
    sub_category: "N/A",
    created_date: "2021-04-30 06:47:58",
    assigned_to: "",
    short_description: "test",
    notes: "",
    incident_state: "New",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-04-30 06:47:58",
    inc_closed_at: "",
    inc_resolved_at: "",
    project_name: "Nestlé",
    account_name: "",
    inc_sys_id: "c94a6682db77ec94052ddda5ca96198a",
    caller: "Dhruv Pankajbhai Soni",
    caller_email: "dhrsoni@deloitte.com",
    inc_cmdb_ci: "",
    sla_response_breached: "TRUE",
    sla_resolution_breached: "TRUE"
  },
  {
    incident_number: "INC0198133",
    priority: "2 - High",
    environment: "",
    category: "N/A",
    sub_category: "N/A",
    created_date: "2021-04-27 13:20:41",
    assigned_to: "",
    short_description: "c",
    notes: "",
    incident_state: "New",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-04-27 13:20:41",
    inc_closed_at: "",
    inc_resolved_at: "",
    project_name: "Nestlé",
    account_name: "us-con-aws-npd-0000118",
    inc_sys_id: "d0672091dbbba094052ddda5ca96195e",
    caller: "CMS Portal Service Account ",
    caller_email: "",
    inc_cmdb_ci: "us-con-aws-npd-0000118",
    sla_response_breached: "TRUE",
    sla_resolution_breached: "TRUE"
  },
  {
    incident_number: "INC0198126",
    priority: "1 - Critical",
    environment: "",
    category: "N/A",
    sub_category: "N/A",
    created_date: "2021-04-27 13:03:08",
    assigned_to: "",
    short_description: "dasdasdwe",
    notes: "",
    incident_state: "New",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-04-27 13:03:08",
    inc_closed_at: "",
    inc_resolved_at: "",
    project_name: "Nestlé",
    account_name: "",
    inc_sys_id: "cf53e4dddb3ba094052ddda5ca9619da",
    caller: "Dhruv Pankajbhai Soni",
    caller_email: "dhrsoni@deloitte.com",
    inc_cmdb_ci: "",
    sla_response_breached: "TRUE",
    sla_resolution_breached: "TRUE"
  },
  {
    incident_number: "INC0198127",
    priority: "1 - Critical",
    environment: "",
    category: "N/A",
    sub_category: "N/A",
    created_date: "2021-04-27 13:06:10",
    assigned_to: "",
    short_description: "dasdasdas",
    notes: "",
    incident_state: "New",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-04-27 13:06:10",
    inc_closed_at: "",
    inc_resolved_at: "",
    project_name: "Nestlé",
    account_name: "",
    inc_sys_id: "ff042851db7bac503cdde415ca9619c2",
    caller: "Dhruv Pankajbhai Soni",
    caller_email: "dhrsoni@deloitte.com",
    inc_cmdb_ci: "",
    sla_response_breached: "TRUE",
    sla_resolution_breached: "TRUE"
  },
  {
    incident_number: "INC0198157",
    priority: "4 - Low",
    environment: "",
    category: "N/A",
    sub_category: "N/A",
    created_date: "2021-04-27 21:04:14",
    assigned_to: "",
    short_description: "test test",
    notes: "",
    incident_state: "New",
    assignment_group_name: "DevOps Ninja",
    inc_opened_at: "2021-04-27 21:04:14",
    inc_closed_at: "",
    inc_resolved_at: "",
    project_name: "Nestlé",
    account_name: "",
    inc_sys_id: "ee71ded1db732494052ddda5ca96193c",
    caller: "Chen Liu",
    caller_email: "chliu@deloitte.com",
    inc_cmdb_ci: "",
    sla_response_breached: "TRUE",
    sla_resolution_breached: "TRUE"
  }
]

export const mockCrDetails = [
  {
    change_number: "CHG0096425",
    priority: "5 - Planning",
    environment: "Sandbox",
    category: "SERVER",
    sub_category: "CHANGE RESOURCES (CPU/MEM/DISK)",
    created_date: "2021-03-01 18:44:43",
    assigned_to: "Abraham Martinez",
    short_description: "Modify server change request",
    notes: "",
    change_state: "Assess",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-01 18:44:42",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-03-01 18:43:53",
    chg_end_date: "2021-03-01 18:46:03",
    cloud_service_account: "us-con-gcp-sbx-0000292",
    account_id: "uscongcpsbx0000292020421",
    chg_sys_id: "42bec0cbdb2aa8143cdde415ca9619b9",
    chg_opened_by: "Kyle Kleier",
    opened_by_email: "kkleier@deloitte.com",
    chg_cmdb_ci: ""
  },
  {
    change_number: "CHG0096495",
    priority: "5 - Planning",
    environment: "",
    category: "ENVIRONMENT",
    sub_category: "OTHER",
    created_date: "2021-03-09 13:45:17",
    assigned_to: "",
    short_description: "Test123",
    notes: "",
    change_state: "Scheduled",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-09 13:45:17",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-03-11 13:44:42",
    chg_end_date: "2021-03-11 13:44:48",
    cloud_service_account: "",
    account_id: "b74114ef7ad0418198b740259509d53e",
    chg_sys_id: "83171029dbb6a8103cdde415ca96192c",
    chg_opened_by: "Sindhuri Jalagam",
    opened_by_email: "sjalagam@deloitte.com",
    chg_cmdb_ci: ""
  },
  {
    change_number: "CHG0096496",
    priority: "5 - Planning",
    environment: "",
    category: "ENVIRONMENT",
    sub_category: "OTHER",
    created_date: "2021-03-09 13:50:47",
    assigned_to: "",
    short_description: "Test123",
    notes: "",
    change_state: "Scheduled",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-09 13:50:47",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-03-11 13:44:42",
    chg_end_date: "2021-03-11 13:44:48",
    cloud_service_account: "",
    account_id: "b74114ef7ad0418198b740259509d53e",
    chg_sys_id: "6758d8a9dbb6a8103cdde415ca96193c",
    chg_opened_by: "Sindhuri Jalagam",
    opened_by_email: "sjalagam@deloitte.com",
    chg_cmdb_ci: ""
  },
  {
    change_number: "CHG0096497",
    priority: "5 - Planning",
    environment: "",
    category: "ENVIRONMENT",
    sub_category: "OTHER",
    created_date: "2021-03-09 13:52:06",
    assigned_to: "",
    short_description: "Test123",
    notes: "",
    change_state: "Scheduled",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-09 13:52:06",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-03-11 13:44:42",
    chg_end_date: "2021-03-11 13:44:48",
    cloud_service_account: "",
    account_id: "b74114ef7ad0418198b740259509d53e",
    chg_sys_id: "43a818e9dbb6a8103cdde415ca9619e9",
    chg_opened_by: "Sindhuri Jalagam",
    opened_by_email: "sjalagam@deloitte.com",
    chg_cmdb_ci: ""
  },
  {
    change_number: "CHG0096498",
    priority: "5 - Planning",
    environment: "",
    category: "ENVIRONMENT",
    sub_category: "OTHER",
    created_date: "2021-03-09 13:56:25",
    assigned_to: "",
    short_description: "Test123",
    notes: "",
    change_state: "Scheduled",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-09 13:56:25",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-03-11 13:44:42",
    chg_end_date: "2021-03-11 13:44:48",
    cloud_service_account: "",
    account_id: "b74114ef7ad0418198b740259509d53e",
    chg_sys_id: "86a918addbb6a8103cdde415ca961905",
    chg_opened_by: "Sindhuri Jalagam",
    opened_by_email: "sjalagam@deloitte.com",
    chg_cmdb_ci: ""
  },
  {
    change_number: "CHG0096499",
    priority: "5 - Planning",
    environment: "",
    category: "ENVIRONMENT",
    sub_category: "OTHER",
    created_date: "2021-03-09 14:08:12",
    assigned_to: "",
    short_description: "Test123",
    notes: "",
    change_state: "Scheduled",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-09 14:08:12",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-03-11 13:44:42",
    chg_end_date: "2021-03-11 13:44:48",
    cloud_service_account: "",
    account_id: "b74114ef7ad0418198b740259509d53e",
    chg_sys_id: "3a5c5c25dbf6a8103cdde415ca9619e5",
    chg_opened_by: "Sindhuri Jalagam",
    opened_by_email: "sjalagam@deloitte.com",
    chg_cmdb_ci: ""
  },
  {
    change_number: "CHG0096500",
    priority: "5 - Planning",
    environment: "",
    category: "ENVIRONMENT",
    sub_category: "OTHER",
    created_date: "2021-03-09 14:12:23",
    assigned_to: "",
    short_description: "Test123",
    notes: "",
    change_state: "Scheduled",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-09 14:12:23",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-03-11 13:44:42",
    chg_end_date: "2021-03-11 13:44:42",
    cloud_service_account: "",
    account_id: "b74114ef7ad0418198b740259509d53e",
    chg_sys_id: "8c5dd8a5dbf6a8103cdde415ca9619e3",
    chg_opened_by: "Sindhuri Jalagam",
    opened_by_email: "sjalagam@deloitte.com",
    chg_cmdb_ci: ""
  },
  {
    change_number: "CHG0096501",
    priority: "5 - Planning",
    environment: "Sandbox",
    category: "ENVIRONMENT",
    sub_category: "OTHER",
    created_date: "2021-03-09 14:22:48",
    assigned_to: "Abi George Oommen",
    short_description: "Test123",
    notes: "",
    change_state: "Implement",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-09 14:22:48",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-03-11 12:44:42",
    chg_end_date: "2021-03-11 13:44:42",
    cloud_service_account: "us-con-gcp-sbx-0000292",
    account_id: "uscongcpsbx0000292020421",
    chg_sys_id: "a0bf1caddbf6a8103cdde415ca9619ec",
    chg_opened_by: "Sindhuri Jalagam",
    opened_by_email: "sjalagam@deloitte.com",
    chg_cmdb_ci: ""
  },
  {
    change_number: "CHG0096502",
    priority: "5 - Planning",
    environment: "",
    category: "ENVIRONMENT",
    sub_category: "OTHER",
    created_date: "2021-03-09 14:30:38",
    assigned_to: "",
    short_description: "Test123",
    notes: "",
    change_state: "Scheduled",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-09 14:30:38",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-03-11 12:44:42",
    chg_end_date: "2021-03-11 13:44:42",
    cloud_service_account: "",
    account_id: "b74114ef7ad0418198b740259509d53e",
    chg_sys_id: "1f716c25db3aa8103cdde415ca96199c",
    chg_opened_by: "Sindhuri Jalagam",
    opened_by_email: "sjalagam@deloitte.com",
    chg_cmdb_ci: ""
  },
  {
    change_number: "CHG0096503",
    priority: "5 - Planning",
    environment: "",
    category: "ENVIRONMENT",
    sub_category: "OTHER",
    created_date: "2021-03-09 14:34:47",
    assigned_to: "",
    short_description: "Test123",
    notes: "",
    change_state: "Scheduled",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-09 14:34:47",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-03-09 12:44:42",
    chg_end_date: "2021-03-09 12:44:42",
    cloud_service_account: "",
    account_id: "b74114ef7ad0418198b740259509d53e",
    chg_sys_id: "88722ce5db3aa8103cdde415ca9619ca",
    chg_opened_by: "Sindhuri Jalagam",
    opened_by_email: "sjalagam@deloitte.com",
    chg_cmdb_ci: ""
  },
  {
    change_number: "CHG0096504",
    priority: "5 - Planning",
    environment: "",
    category: "ENVIRONMENT",
    sub_category: "OTHER",
    created_date: "2021-03-09 15:40:50",
    assigned_to: "",
    short_description: "test",
    notes: "",
    change_state: "Scheduled",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-09 15:40:50",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-02-24 20:07:39",
    chg_end_date: "2021-02-25 20:07:42",
    cloud_service_account: "",
    account_id: "b74114ef7ad0418198b740259509d53e",
    chg_sys_id: "fb81f821dbfaa8103cdde415ca96190a",
    chg_opened_by: "Sindhuri Jalagam",
    opened_by_email: "sjalagam@deloitte.com",
    chg_cmdb_ci: ""
  },
  {
    change_number: "CHG0096505",
    priority: "5 - Planning",
    environment: "",
    category: "ENVIRONMENT",
    sub_category: "OTHER",
    created_date: "2021-03-09 15:54:14",
    assigned_to: "",
    short_description: "test",
    notes: "",
    change_state: "Scheduled",
    assignment_group_name: "DevOps Ninja",
    chg_opened_at: "2021-03-09 15:54:14",
    chg_closed_at: "",
    project_name: "Nestlé",
    chg_start_date: "2021-02-24 20:07:39",
    chg_end_date: "2021-02-25 20:07:42",
    cloud_service_account: "",
    account_id: "b74114ef7ad0418198b740259509d53e",
    chg_sys_id: "40a4b469dbfaa8103cdde415ca96195a",
    chg_opened_by: "Sindhuri Jalagam",
    opened_by_email: "sjalagam@deloitte.com",
    chg_cmdb_ci: ""
  }
]

export const modularityResponse = {
  u_project_name: "PMS TOTAL",
  u_number: { display_value: "PCA10213123", value: "PCA10213123" },
  u_is_active: { display_value: "true", value: "true" },
  u_portal_components:
    "cloudFinancial_optimization,cloudFinancial_page,cmsReports_page,couldFinancial_spend,infraMonitoring_page,itsm_page,keyRotation_page,monitoringCompliance_page,prismaCloud_page,quickLinks_page,secComp_antiMalware,secComp_fixedVulnerabilities,secComp_page,secComp_vulnerabilities,vmInventory_page,uar_page,itsm_sla,cloudAlerts_page,keyContacts_page"
}

export const toolingResponse = {
  "Backup Management": "N2WS-CPM",
  "Firewall Management": "",
  "Compliance Monitoring": "",
  "Network VPN management": "",
  "Vulnerability Management": "Tenable",
  Monitoring: "DataDog",
  "Change Management": "",
  "Patch Management": "",
  "RBAC-Workload Access": "Okta-ASA",
  "Incident Management": "",
  "Role Based Access Control": "",
  "IDP/IDS": "Trend Micro",
  "Security Information & Event Management": "",
  "Cost Management": "",
  "Log Management": ""
}
